export function defineBackgroundColorClass(hex: string): string {
    const validHex = /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex) ? hex : '#ffffff';
    const style = document.createElement('style');
    const className = `bg-${validHex.replace('#', '')}`;

    style.innerHTML = `.${className} { background-color: ${validHex}; }`;
    document.head.appendChild(style);

    return className;
};
